import {React, FC, createElement, useMemo} from './react'

export {default as Typography } from '@mui/material/Typography'
export {default as Chip} from '@mui/material/Chip'
export {default as Box} from '@mui/material/Box'
export {default as Paper} from '@mui/material/Paper'
export {default as Button} from '@mui/material/Button'
export {default as Select} from '@mui/material/Select'
export {default as Menu} from '@mui/material/Menu'
export {default as MenuItem} from '@mui/material/MenuItem'
export {default as Tooltip} from '@mui/material/Tooltip'
export {default as Popover} from '@mui/material/Popover'
export {default as Fade} from '@mui/material/Fade'
export {default as Dialog} from '@mui/material/Dialog'
export {default as DialogActions} from '@mui/material/DialogActions'
export {default as DialogContent} from '@mui/material/DialogContent'
export {default as DialogTitle} from '@mui/material/DialogTitle'
export {default as InputLabel} from '@mui/material/InputLabel'
export {default as TextField} from '@mui/material/TextField'
export {default as TextareaAutosize} from '@mui/material/TextareaAutosize'
export {default as InputUnstyled} from '@mui/material/InputBase/InputBase'
export {default as InputAdornment} from '@mui/material/InputAdornment'

export {default as makeStyles} from '@mui/styles/makeStyles'
export {default as withStyles} from '@mui/styles/withStyles'

export {default as IconButton} from '@mui/material/IconButton'

export {default as List} from '@mui/material/List'
export {default as ListItem} from '@mui/material/ListItem'
export {default as ListItemIcon} from '@mui/material/ListItemIcon'
export {default as ListItemText} from '@mui/material/ListItemText'

export {default as FormHelperText} from '@mui/material/FormHelperText'
export {default as FormControl} from '@mui/material/FormControl' 
export {default as OutlineInput} from '@mui/material/OutlinedInput'

export {default as ThemeProvider} from '@mui/material/styles/ThemeProvider'
export {default as LegacyThemeProvider} from '@mui/styles/ThemeProvider'

export {default as useMediaQuery} from '@mui/material/useMediaQuery'

export {default as FormControlLabel} from '@mui/material/FormControlLabel'
export {default as Checkbox} from '@mui/material/Checkbox'

export {default as Table} from '@mui/material/Table'
export {default as TableBody} from '@mui/material/TableBody'
export {default as TableCell} from '@mui/material/TableCell'
export {default as TableContainer} from '@mui/material/TableContainer'
export {default as TableHead} from '@mui/material/TableHead'
export {default as TableRow} from '@mui/material/TableRow'
export {default as TableSortLabel} from '@mui/material/TableSortLabel'

export {default as Tabs} from '@mui/material/Tabs'
export {default as Tab} from '@mui/material/Tab'

export {default as CircularProgress} from '@mui/material/CircularProgress'

export {default as ToggleButton} from '@mui/material/ToggleButton'
export {default as ToggleButtonGroup} from '@mui/material/ToggleButtonGroup'


// Icons
export {default as FileDownloadIcon} from '@mui/icons-material/FileDownload'
export {default as ErrorIcon} from '@mui/icons-material/Error'
export {default as ArrowDropDownIcon} from '@mui/icons-material/ArrowDropDown'
export {default as AddIcon} from '@mui/icons-material/Add'
export {default as CheckCircleIcon} from '@mui/icons-material/CheckCircle'
export {default as CloseIcon} from '@mui/icons-material/Close'
export {default as AssignmentIndIcon} from '@mui/icons-material/AssignmentInd'
export {default as AssignmentIcon} from '@mui/icons-material/Assignment'
export {default as AssignmentTurnedInIcon} from '@mui/icons-material/AssignmentTurnedIn'
export {default as KeyboardArrowDownIcon} from '@mui/icons-material/KeyboardArrowDown'
export {default as ArrowForwardIosSharpIcon} from '@mui/icons-material/ArrowForwardIosSharp'
export {default as CancelIcon} from '@mui/icons-material/Cancel'
export {default as MoreVertIcon} from '@mui/icons-material/MoreVert'
export {default as WarningIcon} from '@mui/icons-material/Warning'
export {default as ArrowBackIosIcon} from '@mui/icons-material/ArrowBackIos'

// Font Awesome Icons
import {faUsers, IconDefinition, faArrowAltCircleDown, faTrashAlt, faBars, faQuestionCircle} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"

type SupportedIcon = 'users' | 'arrow' | 'trash' | 'bars' | 'questionCircle'

type IconsMap = {
    [key in SupportedIcon]: IconDefinition
}

const supportedIcons: IconsMap = {
    users: faUsers,
    arrow: faArrowAltCircleDown,
    trash: faTrashAlt,
    bars: faBars,
    questionCircle: faQuestionCircle
}

type FAIconProps = {
    icon: SupportedIcon
}

export const FAIcon: FC<FAIconProps> = (props) => {
    const icon:any = useMemo(() => supportedIcons[props.icon], [props.icon])
    return createElement(FontAwesomeIcon, {...props, icon})
}


// Seems to fit better here
export {default as clsx} from 'clsx'

import {styled} from '@mui/material/styles'

export {styled}

export const captureProps = (...captured:string[]) => (p:string):boolean => captured.indexOf(p) < 0
export const styleAndCapture = (Base:any, ...captured:string[]) => styled(Base, {shouldForwardProp: captureProps(...captured)})

export {default as createTheme} from '@mui/material/styles/createTheme'
export {default as useTheme} from '@mui/material/styles/useTheme'

export { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
export { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker'
export { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
export { DatePicker } from '@mui/x-date-pickers/DatePicker'

export {default as AccordionSummary, accordionSummaryClasses } from '@mui/material/AccordionSummary'
export type {AccordionSummaryProps} from '@mui/material/AccordionSummary'
export {default as Accordion} from '@mui/material/Accordion'
export {default as AccordionDetails} from '@mui/material/AccordionDetails'

export {default as StyledEngineProvider} from '@mui/material/StyledEngineProvider'
